var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "强制阅读",
        visible: _vm.visi,
        width: "35%",
        "close-on-click-modal": false
      },
      on: { close: _vm.closePup }
    },
    [
      _c(
        "el-form",
        {
          staticStyle: { "margin-top": "20px" },
          attrs: { model: _vm.formInItem }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "" } },
            [
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.formInItem.needRead,
                    callback: function($$v) {
                      _vm.$set(_vm.formInItem, "needRead", $$v)
                    },
                    expression: "formInItem.needRead"
                  }
                },
                [
                  _vm._v("需阅读\n        "),
                  _c(
                    "span",
                    {
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c("el-input-number", {
                        attrs: { size: "mini", min: 5, max: 300 },
                        model: {
                          value: _vm.formInItem.readTime,
                          callback: function($$v) {
                            _vm.$set(_vm.formInItem, "readTime", $$v)
                          },
                          expression: "formInItem.readTime"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v("\n        秒并阅读至合同末尾")
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.closePup } },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.setConfirm }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c225e26", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c225e26","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/initiation/components/readPup.vue
// module id = WAn5
// module chunks = 2 3 228